// store/middleware/syncCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";
import { getCacheVersion } from "../../config/runtimeConfig";

export const syncCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type?.startsWith("sync/")) {
      const state = store.getState();
      const pendingActions = state.sync.pendingActions;

      try {
        const version = getCacheVersion();
        const CACHE_KEY = `sync_pending_v${version}`;
        saveToStorage(CACHE_KEY, {
          actions: pendingActions,
          timestamp: Date.now(),
        });
      } catch (error) {
        console.error("❌ Ошибка сохранения кэша синхронизации:", error);
      }
    }

    return result;
  };